// "Deliver to a different address" toggle for the checkout's details step.
//
// WooCommerce's own wc-checkout script normally does this, but it is dequeued on that step
// (see amenities_checkout_dequeue_wc_checkout_script() in includes/checkout-steps.php) because
// it would also hijack the form submit into an order-creating AJAX checkout. This replaces just
// the toggle, using the same native ids/classes WooCommerce uses, so nothing else has to change.
function initShipToDifferentAddress(checkbox) {
    const panel = document.querySelector('.shipping_address');

    if (!panel) return;

    function sync() {
        panel.hidden = !checkbox.checked;
    }

    checkbox.addEventListener('change', sync);
    sync();
}

document.addEventListener('DOMContentLoaded', () => {
    const checkbox = document.getElementById('ship-to-different-address-checkbox');

    if (checkbox) initShipToDifferentAddress(checkbox);
});
